/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["body[_ngcontent-%COMP%], html[_ngcontent-%COMP%]{font-family:Montserrat,sans-serif!important}.text-center[_ngcontent-%COMP%]{justify-content:center!important}.margin2[_ngcontent-%COMP%]{margin-left:7px}"];
export { styles as styles };

